// extracted by mini-css-extract-plugin
export default {"component":"CardsGrid__component--ig-zBhmH","list":"CardsGrid__list--ig-GJz8U","item":"CardsGrid__item--ig-uSY4L"};